import {
  Box, Grid, Typography, useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Login } from './Login';
import { useLogo } from '../../config/useLogo';

export default function LoginDesktopLayout() {
  const theme = useTheme();
  const { t } = useTranslation();
  const { loginImage } = useLogo();
  return (
    <Grid container spacing={{ xs: 2 }}>
      <Grid item xs={6}
        sx={{
          textAlign: 'center',
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
          background: theme.palette.common.white,
        }}
      >
        <Login />
      </Grid>
      <Grid item xs={6}
        sx={{
          paddingTop: ` ${theme.spacing(0)} !important`,
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
          background: theme.palette.grey[100],
        }}
      >
        <Box display='flex' flexDirection={'column'}
          sx={{
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant='h12'
            sx={{
              mb: theme.spacing(8),
            }}
          >
            {t('login.imageHeading')}
          </Typography>
          <img
            src={loginImage as string}
            alt={'login_page_logo'}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
